import LookerLabs from 'components/Icons/LookerLabs'
import InfoBox from 'components/InfoBox'
import { buildTranslate } from 'locales'

const t = buildTranslate('insights_lab.banner')

const InsightsLabBanner = () => {
  return (
    <InfoBox
      type="tip"
      title={t('title')}
      content={t('description')}
      className="my-xxl"
      iconOverride={<LookerLabs className="d-flex mt-xxs" />}
    />
  )
}

export default InsightsLabBanner
